import React from 'react';
import { Input as HeroInput } from '@heroui/react';

interface InputProps {
  label?: string;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  type?: 'text' | 'email' | 'password' | 'number' | 'tel' | 'url';
  isRequired?: boolean;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  isClearable?: boolean;
  size?: 'sm' | 'md' | 'lg';
  color?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
  variant?: 'bordered' | 'underlined' | 'filled' | 'flat';
  className?: string;
  classNames?: any;
  description?: string;
  errorMessage?: string;
  startContent?: React.ReactNode;
  endContent?: React.ReactNode;
  radius?: 'none' | 'sm' | 'md' | 'lg' | 'full';
  fullWidth?: boolean;
  min?: number;
  max?: number;
}

export const Input: React.FC<InputProps> = ({
  label,
  placeholder,
  value = '',
  onChange,
  onBlur,
  type = 'text',
  isRequired = false,
  isDisabled = false,
  isReadOnly = false,
  isClearable = false,
  size = 'sm',
  color = 'default',
  variant = 'bordered',
  className = '',
  description,
  errorMessage,
  startContent,
  endContent,
  radius = 'md',
  fullWidth = false,
  classNames = {},
  min,
  max,
}) => {
  return (
    <div className={`flex flex-col gap-2 ${fullWidth ? 'w-full' : ''} ${className}`}>
      <HeroInput
        label={label}
        placeholder={placeholder}
        labelPlacement="outside"
        value={value}
        onValueChange={onChange}
        onBlur={onBlur}
        type={type}
        isRequired={isRequired}
        isDisabled={isDisabled}
        isReadOnly={isReadOnly}
        isClearable={isClearable}
        size={size}
        min={min}
        max={max}
        color={color}
        //@ts-ignore
        variant={variant}
        description={description}
        errorMessage={errorMessage}
        startContent={startContent}
        endContent={endContent}
        radius={radius}
        fullWidth={fullWidth}
        classNames={{
          ...classNames,
          base: 'min-h-10',
          input: 'text-sm h-[2.375rem] text-auth-ink',
          label: 'text-sm font-medium text-auth-ink',
          description: 'text-xs text-auth-muted',
          errorMessage: 'text-xs text-auth-strength-weak',
        }}
      />
    </div>
  );
};
